import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getOrigin(page) {
  const data = await getFetch(`/Location/origin/get?page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeOrigin(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'مبدا الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Location/origin/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'مبدا با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}

async function deleteOrigin(id) {
  const res = await postFetchWithBody(`/Location/origin/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getOrigin, storeOrigin,deleteOrigin };
